module.exports = __webpack_public_path__ + "img/bnr_footer02.c1407252.png";